import React from 'react';
import { ReturnService } from '../../services';
import { useNotification } from '../../contexts/NotificationContext';
import { useError } from '../../contexts/ErrorContext';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import { formatDate, getCurrentDateFormatted } from '../../utils/formatters';
import { isSuccessfulResponse } from '../../utils/responseHelpers';

const PRCheckboxCell = (props) => {
    const { createErrorNotification } = useNotification();
    const { showError } = useError();

    const handlePRClick = async () => {
        if (props.value) {
          updatePR(false);
        } else {
          updatePR(true);
        }
    }

    const handleOldPRClick = async () => {
        createErrorNotification(`Cannot update old principle reduction.`);
    }
    const updatePR = async (value) => {
        try {
            const response = await ReturnService.updateReturn(props.id, {isPrincipalReduction: value});
            if (isSuccessfulResponse(response)) {
                // TODO: Improve me
                console.log(props.value)
                setTimeout(() => window.location.reload(), 100);
            } else {
                createErrorNotification(" to change notification setting.");
            }
          } catch (err) {
              showError(err);
          }
    }
    return props.disableUpdates ? (props.value ?
        <CheckBoxIcon/> : 
        <CheckBoxOutlineBlank/>) :
        (formatDate(props.date) === getCurrentDateFormatted() ?
        (props.value ?
        <CheckBoxIcon onClick={handlePRClick}/> : 
        <CheckBoxOutlineBlank onClick={handlePRClick}/>) :
        (props.value ?
        <CheckBoxIcon onClick={handleOldPRClick}/> : 
        <CheckBoxOutlineBlank onClick={handleOldPRClick}/>));

}


export default PRCheckboxCell;